"use client";

import { parseAsInteger, parseAsString, useQueryStates } from "nuqs";

import { DEFAULT_CATALOG_SORT } from "../types/catalog.type";

export function useCatalogSettings() {
  return useQueryStates({
    page: parseAsInteger.withDefault(1),
    sort: parseAsString.withDefault(DEFAULT_CATALOG_SORT),
  });
}
